import sortingIcon from '../../../assets/images/Sorting_icon.svg';
import styles from './ApprovalDataTable.module.scss';

/**
 * ApprovalDataTable 컴포넌트
 * - 결재 관련 데이터 테이블 공용 컴포넌트
 * - 컬럼 정의와 데이터를 props로 받아 동적으로 렌더링
 */
export default function ApprovalDataTable({
  columns = [],
  data = [],
  getRowKey,
  onRowClick,
  onSort, //정렬이벤트 핸들러
  sortField, // 현재 정렬 기준
  emptyContent, // 테이블이 비엇을떄
}) {
  function getDefaultRowKey(item, index) {
    if (getRowKey) {
      return getRowKey(item, index);
    }
    return item.id || item.key || index;
  }

  function handleRowClick(item) {
    if (onRowClick) {
      onRowClick(item);
    }
  }

  return (
    <div className={styles.tableContainer}>
      <table className={styles.table}>
        <thead>
          <tr>
            {columns.map(function (column) {
              const isSortable = column.sortable !== false && onSort;
              const isSorted = sortField && sortField.field === column.key;
              const sortDirection = isSorted ? sortField.direction : null;
              const headerContent = column.headerRender
                ? column.headerRender(column, data)
                : column.label;

              return (
                <th
                  key={column.key}
                  className={`${column.className || ''} ${isSortable ? styles.sortable : ''} ${isSorted ? styles.sorted : ''}`}
                  style={column.width ? { width: column.width } : undefined}
                  onClick={isSortable ? () => onSort(column.key) : undefined}
                >
                  <div className={styles.headerInner}>
                    <div className={styles.headerContent}>{headerContent}</div>
                    {isSortable && (
                      <img
                        className={styles.sortingIcon}
                        src={sortingIcon}
                        alt=""
                        aria-hidden="true"
                      />
                    )}
                  </div>
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {data.length === 0 ? (
            <tr>
              <td colSpan={columns.length} className={styles.emptyRow}>
                <div className={styles.emptyCell}>{emptyContent}</div>
              </td>
            </tr>
          ) : (
            data.map(function (item, index) {
              const isCompleted = item.exeState === 1 || item.exeState === '1';

              return (
                <tr
                  key={getDefaultRowKey(item, index)}
                  onClick={onRowClick ? () => handleRowClick(item) : undefined}
                  style={onRowClick ? { cursor: 'pointer' } : undefined}
                  className={isCompleted ? styles.completedRow : ''}
                >
                  {columns.map(function (column) {
                    const cellValue = column.render
                      ? column.render(item[column.key], item, index)
                      : item[column.key];

                    return (
                      <td
                        key={column.key}
                        className={column.className || ''}
                        style={column.width ? { width: column.width } : undefined}
                        onClick={column.stopPropagation ? (e) => e.stopPropagation() : undefined}
                        title={typeof cellValue === 'string' ? cellValue : undefined}
                      >
                        <div className={styles.ellipsisCell}>{cellValue}</div>
                      </td>
                    );
                  })}
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
}
